import {Grid} from "@mui/system";
import {ReactNode} from "react";

type Props = {
  children: ReactNode;
  config: {
    visible: boolean;
    size?: number;
  };
};

const VoyageVisibility = (props: Props) => {
  const {config, children} = props;
  const {visible, size = 3} = config;

  if (!visible) return null;

  return <Grid size={size}>{children}</Grid>;
};

export default VoyageVisibility;
